import React from "react";
import { Grid, Text, Alert, Paper, Stack } from "@mantine/core";
import { IconAlertTriangle } from "@tabler/icons";
import { formatFundAmount } from "../helpers/approvalFundListFundFields";

const SummaryItem = ({ label, value, highlight = false }) => (
  <div>
    <Text size="xs" color="dimmed" mb={4}>
      {label}
    </Text>
    <Text size={highlight ? "md" : "sm"} weight={highlight ? 700 : 500}>
      {value ?? "—"}
    </Text>
  </div>
);

const yesNo = (value) => (value ? "Yes 是" : "No 否");

const formatAmount = (amount, currency) => {
  if (amount == null || amount === "") return "—";
  const formatted = formatFundAmount(amount);
  return currency ? `${formatted} ${currency}` : formatted;
};

const OrderArFormProductConfirm = ({ form }) => {
  const {
    fundName,
    riskRating,
    trailerFee,
    complexProduct,
    affiliatedFwd,
    fundCurrency,
    subscribedAmount,
    minSubscriptionAmount,
  } = form?.values ?? {};

  const hasErrors = !form.isValid?.() && Object.keys(form.errors ?? {}).length > 0;

  return (
    <Stack spacing="lg">
      {hasErrors && (
        <Alert
          icon={<IconAlertTriangle size={16} />}
          color="red"
          title="Please review the form"
        >
          Some fields need attention. Go back to the previous steps to fix them.
        </Alert>
      )}

      <Paper withBorder p="lg" radius="sm">
        <Text size="xs" color="dimmed" mb="md">
          Subscription summary 認購摘要
        </Text>
        <Grid gutter="lg">
          <Grid.Col span={12}>
            <SummaryItem label="Fund Name 基金名稱" value={fundName} />
          </Grid.Col>
          <Grid.Col span={12} sm={6}>
            <SummaryItem
              label="Fund Currency 基金貨幣"
              value={fundCurrency ?? "—"}
            />
          </Grid.Col>
          <Grid.Col span={12} sm={6}>
            <SummaryItem
              label="Subscribed Amount 認購金額"
              value={formatAmount(subscribedAmount, fundCurrency)}
              highlight
            />
          </Grid.Col>
          <Grid.Col span={12} sm={6}>
            <SummaryItem
              label="Risk Rating (1–5) 風險評級"
              value={riskRating ?? "—"}
            />
          </Grid.Col>
          <Grid.Col span={12} sm={6}>
            <SummaryItem
              label="Trailer Fee / Access Fee % 後續費用"
              value={trailerFee != null ? `${trailerFee}%` : "—"}
            />
          </Grid.Col>
          <Grid.Col span={12} sm={6}>
            <SummaryItem
              label="Complex Product #1 複雜產品"
              value={yesNo(complexProduct)}
            />
          </Grid.Col>
          <Grid.Col span={12} sm={6}>
            <SummaryItem
              label="Affiliated company #2 聯繫公司"
              value={yesNo(affiliatedFwd)}
            />
          </Grid.Col>
          {minSubscriptionAmount != null && (
            <Grid.Col span={12}>
              <Text size="sm" color="dimmed">
                Minimum subscribed amount 最低認購金額:{" "}
                {formatAmount(minSubscriptionAmount, fundCurrency)}
              </Text>
            </Grid.Col>
          )}
        </Grid>
      </Paper>
    </Stack>
  );
};

export default OrderArFormProductConfirm;
